import { IRootState } from "../store";

// export const getEnabledApps = createSelector(
//   (state: IRootState) => {
//     return {
//       project: state.adminReducer.project,
//       allApps: state.globalReducer.apps,
//       member: state.adminReducer.project?.members?.find((member) => member.user?._id === state.globalReducer.user._id),
//     };
//   },
//   (projectAndApps: { project: IProject; allApps: IApp[]; member: IMember }) => {
//     const project = projectAndApps.project;
//     const allApps = projectAndApps.allApps;
//     const member = projectAndApps.member;
//     const memberGroup = member && member.group;
//     if (project == null) {
//       return [];
//     }
//     return allApps.filter((app) => {
//       if (memberGroup == null) {
//         return true;
//       }
//       const projectApp = project.apps.find((eApp) => eApp.app === app.name);
//       if (projectApp == null) {
//         return false;
//       }
//       if (projectApp.active === false) {
//         return false;
//       }
//       if (app.enabledInProjects != null) {
//         return app.enabledInProjects.indexOf(project.maconomy.projectNo) !== -1;
//       }
//       if (memberGroup === "INTERNAL" || memberGroup === "ADMIN") {
//         return true;
//       }
//       if (memberGroup === "PARTNER") {
//         return projectApp.access?.partner;
//       }
//       if (memberGroup === "CLIENT") {
//         return projectApp.access?.client;
//       }
//       return false;
//     });
//   },
// );

export const selectCurrentProjectId = (state: IRootState): string | null => state.globalReducer.currentProjectId;
